module.exports = __webpack_public_path__ + "img/Karve2.dd4e48f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/Pune_KarveRoad/Karve2.jpeg
// module id = 1869
// module chunks = 1